import APIRequestState from 'spa/state/_util/api-request';

class ApplePayState extends APIRequestState {
  get method() { return 'POST'; }
  get url() { return '/billing/apple-pay-verification'; }
}

export default ApplePayState;



// WEBPACK FOOTER //
// ./spa/state/_util/apple-pay.jsx